import { CdkDragDrop, DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule } from "@angular/common";
import { booleanAttribute, Component, input, signal } from "@angular/core";
import {
    ControlValueAccessorAdpater,
    controlValueAccessorProvider,
    FileSizePipe,
    Icon,
    Label,
    Spinner,
} from "@malirang/front-share";

@Component({
    selector: "app-abnormal-payment-file-uploader",
    templateUrl: "./abnormal-payment-file-uploader.component.html",
    styleUrls: ["./abnormal-payment-file-uploader.component.css"],
    imports: [CommonModule, Spinner, Icon, Label, DragDropModule, FileSizePipe],
    providers: [
        controlValueAccessorProvider(AbnormalPaymentFileUploaderComponent),
    ],
})
export class AbnormalPaymentFileUploaderComponent extends ControlValueAccessorAdpater<File> {
    label = input<string>("");
    required = input<boolean, string>(false, { transform: booleanAttribute });

    // 드래그/드롭 시 드래그가 끝났는지 여부
    isDragOvered = signal(false);

    onDragOver(e: DragEvent) {
        if (this.value()) {
            return;
        }
        this.isDragOvered.set(true);
        e.preventDefault();
    }

    onDragLeave(e: DragEvent) {
        if (this.value()) {
            return;
        }
        this.isDragOvered.set(false);
        e.preventDefault();
    }

    onDragDrop(e: DragEvent) {
        if (this.value()) {
            return;
        }
        this.isDragOvered.set(false);

        if (e.dataTransfer?.files?.length) {
            const file = e.dataTransfer.files.item(0);
            if (file) {
                this.writeValue(file);
            }
        }

        e.preventDefault();
    }

    handleClick() {
        if (this.value()) {
            return;
        }

        const fileInput = document.createElement("input");
        fileInput.type = "file";
        fileInput.accept = ".xlsx, .xls";
        fileInput.onchange = (e: Event) => {
            const target = e.target as HTMLInputElement;
            const file = target.files?.item(0);
            if (file) {
                this.writeValue(file);
            }
        };
        fileInput.click();
    }
}
